import { render, staticRenderFns } from "./data86.vue?vue&type=template&id=64a08070&scoped=true"
import script from "./data86.vue?vue&type=script&lang=js"
export * from "./data86.vue?vue&type=script&lang=js"
import style1 from "./data86.vue?vue&type=style&index=1&id=64a08070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a08070",
  null
  
)

export default component.exports